import { render, staticRenderFns } from "./ShippingDocumentHandle.vue?vue&type=template&id=9f203fba&"
import script from "./ShippingDocumentHandle.vue?vue&type=script&lang=js&"
export * from "./ShippingDocumentHandle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports